import $ from 'jquery';
import {gsap, ScrollTrigger} from '../../js/wrapper/gsap.mjs';
import {
  deviceIsMinLg, devicePrefersReducedMotion,
  gridBreakpoints,
} from '../../js/utilities/media-queries.mjs';
import {initRevealAnimation} from '../../js/Ui.mjs';

const CSS_CLASS_CARD = '.ef-collection-card';
const $grids = $(`${CSS_CLASS_CARD}-grid`);
const $cards = $(`${CSS_CLASS_CARD}.-grid`);

ScrollTrigger.matchMedia({
  // On large devices attach parallax animation
  [`(min-width: ${gridBreakpoints.lg}px) and (prefers-reduced-motion: no-preference)`]: function() {
    $grids.each((index, grid) => {
      const $items = $(grid).find('.reveal-md-down');
      const images = $(grid).find('.img-fluid').toArray();

      // Cleanup
      gsap.set($items.toArray(), {clearProps: 'all'});

      // Setup
      gsap.set(images, {
        y: -45,
      });

      // Animate
      gsap.to(images, {
        y: 45,
        ease: 'none',
        scrollTrigger: {
          trigger: grid,
          scrub: true,
          // markers: true, // Enable for debug indicators
        },
      });
    });
  },
  // On smaller devices manually cleanup instead of ScrollTrigger.saveStyles()
  // @see https://greensock.com/forums/topic/28364-scrolltriggersavestyles-reset-styles-from-gsapset/
  [`(max-width: ${gridBreakpoints.lg - 1}px), (prefers-reduced-motion: reduce)`]: function() {
    $grids.each((index, grid) => {
      const $items = $(grid).find('.reveal-md-down');
      const images = $(grid).find('.img-fluid').toArray();

      // Cleanup
      gsap.set(images, {clearProps: 'all'});

      // Setup
      initRevealAnimation($items);
    });
  },
});

deviceIsMinLg.addListener(handleViewport);
handleViewport(deviceIsMinLg);

/**
 * @param {MediaQueryList} deviceIsMinLgMql
 */
function handleViewport(deviceIsMinLgMql) {
  $cards.each((index, card) => {
    const $card = $(card);
    const $inner = $card.find(`${CSS_CLASS_CARD}__inner`);
    const $text = $card.find(`${CSS_CLASS_CARD}__text`);

    if (deviceIsMinLgMql.matches && devicePrefersReducedMotion.matches === false) {
      /*
       * Large and up
       */
      const textHeight = $text.get(0).scrollHeight || 0;

      /*
       * TODO: Maybe listen for resize event to recalculate within a large
       *  viewport. But it's good enough without it for now.
       */
      // Prepare styles for animation
      $inner.css('transform', `translateY(${(textHeight / 2)}px)`);
      $text.css('height', textHeight);
      // Wait until CSS is set
      setTimeout(() => {
        $card.addClass('js_animate');
      }, 100);

      // Add animation trigger
      $card.on('mouseenter focusin', () => {
        $card.addClass('js_hover');
      });
      $card.on('mouseleave focusout   ', () => {
        $card.removeClass('js_hover');
      });
    } else {
      /*
       * Medium and down
       */
      // Cleanup
      $card.removeClass('js_animate');
      $inner.attr('style', '');
      $text.attr('style', '');
      $card.off('mouseenter focusin mouseleave focusout');
    }
  });
}
